import { Instance, SnapshotOut, types } from 'mobx-state-tree';
import { CodeModel } from 'src/models/common-code/CommonCode';
import { withSetPropAction } from 'src/models/extensions/withSetPropAction';
import { OperatorInfo } from 'src/models/operator-info/OperatorInfo';

/**
 * # Partner
 *
 * Partner을 설명하세요.
 */
export const Partner = types
  .model('Partner')
  .props({
    partnerSid: types.number,
    partnerName: types.maybeNull(types.string),
    logoImgPath: types.maybeNull(types.string),
    partnerCtgyCd: types.maybeNull(CodeModel),
    useYn: types.optional(types.boolean, true),
    ordr: types.optional(types.number, 0),
    delYn: types.optional(types.boolean, false),
    regUser: types.maybeNull(OperatorInfo),
    updUser: types.maybeNull(OperatorInfo),
    regDt: types.optional(types.maybeNull(types.number), 0),
    updDt: types.optional(types.maybeNull(types.number), 0),
  })
  .volatile(() => ({
    files: types.maybeNull(types.array(types.frozen())),
  }))
  .actions(withSetPropAction);

// --------------------------------------------------------------------------
type TPartner = Instance<typeof Partner>;
type TPartnerSnapshot = SnapshotOut<typeof Partner>;

export interface IPartner extends TPartner {}
export type TPartnerKeys = keyof TPartnerSnapshot & string;
export interface IPartnerSnapshot extends TPartnerSnapshot {}
export const createPartner = () => types.optional(Partner, {} as TPartner);
